export let GatePath = /*#__PURE__*/function (GatePath) {
  GatePath["RESULTS"] = "/results";
  GatePath["GATE"] = "/";
  return GatePath;
}({});
//# sourceMappingURL=types.js.map